module.exports = __webpack_public_path__ + "static/sort_near-aabb8c926830a57b97e77f2ca5b5b5f8.png";